export default __webpack_public_path__ + "75d1a3ae1e99585f24bf6479094c13a2.svg";